<ion-col>
    <ion-button [disabled]="disabled" [color]="(active && !disabled) ? color : 'light'" [ngClass]="{'shade': (!active || disabled)}" mode="md" expand="full">
        <ng-content></ng-content>
    </ion-button>
</ion-col>